import AuthHeaderManager from "@roman/shared/lib/auth/AuthHeaderManager";
import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import type { RoundEntryUnit } from "@roman/shared/types/RoundEntryUnit";
import useSWR, { type SWRConfiguration } from "swr";
import type { Language, LanguageQuery } from "../../types/Language";

interface RoundEntryUnitsResponse {
  roundEntryUnit: RoundEntryUnit;
}

const fetcher = (url: string, lang: Language) => {
  const headers = AuthHeaderManager.getInstance().getAuthorizationHeader();
  return romanApi.get<RoundEntryUnitsResponse, LanguageQuery>(url, { lang }, { headers });
};

interface RoundEntryUnitResponse {
  roundEntryUnitId: string;
  lang: Language;
  swrOptions?: SWRConfiguration;
}

export const useRoundEntryUnit = ({ roundEntryUnitId, lang, swrOptions }: RoundEntryUnitResponse) => {
  const queryKey = [`/soccer/roundEntryUnits/${roundEntryUnitId}`, lang];

  const swrQuery = useSWR<RoundEntryUnitsResponse, RomanApiError>(
    queryKey,
    ([url, lang]: [string, Language]) => fetcher(url, lang),
    swrOptions,
  );

  const roundEntryUnit = swrQuery.data?.roundEntryUnit;

  return {
    roundEntryUnit,
    ...swrQuery,
  };
};
